import {Component, inject} from '@angular/core';
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {ICellRendererParams} from "ag-grid-community";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {PaymentService} from "../../../services/payment.service";
import {MatDialog} from "@angular/material/dialog";
import {EMPTY, Observable} from "rxjs";
import {switchMap} from "rxjs/operators";
import {IssueRefundReasonDialogComponent} from "../../dialogs/issue-refund-reason/issue-refund-reason.component";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IIssueRefund} from "../../../interfaces/IIssueRefund";
import {ActiveUserService} from "../../../services/active-user.service";
import {GameService} from "../../../services/game.service";
import {ReceiptService} from "../../../services/receipt.service";
import {SnackbarService} from "../../../services/snackbar.service";

@Component({
  selector: 'app-player-transaction-options',
  standalone: true,
  imports: [
    HasPermissionDirective,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatTooltip,
    MatMenuTrigger
  ],
  templateUrl: './player-transaction-options.component.html',
  styleUrl: './player-transaction-options.component.css'
})
export class PlayerTransactionOptionsComponent {
  params!: ICellRendererParams;
  public permissionTypes = PermissionTypes;

  private paymentService = inject(PaymentService);
  private gameService = inject(GameService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  private activeUserService: ActiveUserService = inject(ActiveUserService);
  private receiptService = inject(ReceiptService);
  private snackBarService = inject(SnackbarService);

  private dialog: MatDialog = inject(MatDialog);

  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public isDownloadingReceipt = false;

  public activeGame = this.gameService.activeGame();

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  get rowData() {
    return this.params?.data;
  }

  public onIssueRefund(paymentIdP: string): void {

    const dialogRef = this.dialog.open(IssueRefundReasonDialogComponent, {
      disableClose: true,
      width: '900px'
    });

    dialogRef.afterClosed().pipe(
      switchMap(result => {
        if (result) {
          this.uiState = UIStateEnum.ShowLoading;
          return this.submitRefund(result, paymentIdP);
        } else {
          return EMPTY;
        }
      })
    ).subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
      },
        error: (err) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }

  private submitRefund(dialogResultP: any, paymentIdP: string): Observable<any> {

    const refundRequest: IIssueRefund = {
      adminId: this.activeUserService.activeUser().Id,
      gameId: this.rowData.GameId,
      stripeChargeId: paymentIdP,
      reason: dialogResultP.refundReason

    }

    return this.paymentService.issueRefund(refundRequest);
  }

  public downloadReceipt(): void {
    if (!this.rowData || this.isDownloadingReceipt) return;

    this.isDownloadingReceipt = true;
    this.receiptService.getReceiptByPaymentId(this.rowData.PlayerPaymentId, this.rowData.GameId).subscribe({
      next: async (receiptData) => {
        await this.receiptService.generateReceiptPDF(receiptData);
        this.isDownloadingReceipt = false;
        this.snackBarService.openSuccessfulSnackBar('Receipt downloaded successfully');
      },
      error: () => {
        this.isDownloadingReceipt = false;
        this.snackBarService.openErrorSnackBar('Failed to download receipt. Please try again.');
      }
    });
  }
}
